import { render } from "./EditPayrollGlobalDeductionRule.vue?vue&type=template&id=b42f3602&scoped=true"
import script from "./EditPayrollGlobalDeductionRule.vue?vue&type=script&lang=js"
export * from "./EditPayrollGlobalDeductionRule.vue?vue&type=script&lang=js"

import "./EditPayrollGlobalDeductionRule.vue?vue&type=style&index=0&id=b42f3602&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b42f3602"]])

export default __exports__